import ProductSwatch from './ProductSwatch';
export * from './ProductSwatch';
export default ProductSwatch;
